import { Navigate, Outlet } from 'react-router-dom';
import type { ReactElement } from 'react';
import { ROUTES } from '@/app/config/constants';
import { useAppSelector } from '@/app/store/hooks';
import { selectIsSupplierRole } from '@/features/authentication';

/**
 * Which BIDs a session opens, by its role (2026-10-27).
 *
 * BIDs are the buyer's screens (`/rfqs`, guarded by the Request For Quotation grant) for Mega Admin, Admin, Initiator
 * and every other role, unchanged. For the Supplier role -- a supplier signed in to the portal, or a user whose role is
 * Supplier -- BIDs are the Supplier Bid Quotation (`/supplier-bids`, the `supplier/supplier-quotation` feature, which holds the
 * other half of this gate). Each side's URLs send the other side's sessions to their own BIDs, so neither can be opened
 * by typing the other's address; the platform refuses the other side's calls whatever the browser does.
 */

/** The buyer's BIDs: a Supplier-role session is sent to its Supplier Bid Quotation. */
export function BuyerBidsGate(): ReactElement {
  const isSupplier = useAppSelector(selectIsSupplierRole);
  return isSupplier ? <Navigate to={ROUTES.SUPPLIER_BIDS} replace /> : <Outlet />;
}
